module.exports = __webpack_public_path__ + "img/left-arrow.83da6776.svg";